export default __webpack_public_path__ + "static/media/15.706413b8.png";